import { Group, Select, Stack, Stepper } from "@mantine/core";
import { IconArrowDown, IconArrowUp } from "@tabler/icons-react";
import { useMemo } from "react";
import { useLeadsSheetStore } from "../../../../../../../stores/LeadsStore";
import { useLanguage } from "../../../../../../../stores/LanguageStore";
import AddNote from "../activity/note/AddNote";
import TabNotesItem from "./TabNotesItem";

const TabNotes = () => {
  const lang = useLanguage((s) => s.language);
  const current = useLeadsSheetStore((s) => s.current);
  const sort = useLeadsSheetStore((s) => s.sort);
  const setSort = useLeadsSheetStore((s) => s.setSort);

  const orders = useMemo(() => {
    return [
      {
        label: lang.prm.details.filters.desc,
        value: "desc",
      },
      {
        label: lang.prm.details.filters.asc,
        value: "asc",
      },
    ];
  }, [lang.prm.details.filters.asc, lang.prm.details.filters.desc]);

  const notes = useMemo(() => {
    if (!current?.history) {
      return [];
    }
    return current?.history?.filter((x) => !!x?.note);
  }, [current.history]);

  const sortedNotes = useMemo(() => {
    return notes.sort((a, b) => (sort === "desc" ? b.id - a.id : undefined));
  }, [notes, sort, current?.newData]);

  return (
    <Stack
      gap={0}
      flex={1}
      h={0}
      mih={"100%"}
      style={{ overflow: "auto" }}
      p={"lg"}
      px={0}
    >
      <Group mb={"xs"} justify="space-between">
        <Select
          value={sort}
          data={orders}
          w={190}
          size="xs"
          onChange={setSort}
          leftSection={
            sort === "asc" ? (
              <IconArrowUp size={18} />
            ) : (
              <IconArrowDown size={18} />
            )
          }
        />

        <AddNote />
      </Group>

      <Stepper
        active={0}
        iconSize={28}
        size="sm"
        radius={"lg"}
        styles={{ stepIcon: { border: "none", background: "none" } }}
        orientation="vertical"
      >
        {sortedNotes.map((item, index) => (
          <TabNotesItem
            key={item?.id || index}
            item={item}
            isLast={index === notes.length - 1}
          />
        ))}
      </Stepper>
    </Stack>
  );
};

export default TabNotes;
